import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import Axios from 'axios';
import CONFIG from '../../config';
import browserDetect from '../../utils/browserDetect';
import { getParams } from '../../utils';
import firstVisited from '../../utils/firstVisited';
import { getCountryCode } from '../../utils/countryCode';
import { updateUserLocationDetails, pricingPlan, totalAmountToPay, saveSubscriptionType, updateCheckoutPromoCode, updateOfferStatus, updateOfferName } from '../../Actions';
// import { handlePremiumPackage } from '../../utils/pricing';
import { regionalsLangObject } from '../../Data/regionalsArray';
import { animatedRegionalsPaths } from '../../Data/excludedPaths';
import HeaderSnackbar from '../Account/HeaderSnackbar';
import InfoBar from '../Home/Info';
import Header from '../ui/Header';
import Banner from './Banner';
import { SiteStats, CompanyLogos } from '../ui/SiteStats';
import SingleTestimonial from '../ui/SingleTestimonial';
import Courses from './Courses';
// import PriceCard, { PriceCardSkeleton } from '../ui/PriceCard';
// import RegionalsPricing from './RegionalsPricing';
// import RegionalsPrimePricingBar from '../Pricing/PricingBar/RegionalsPrimePricingBar';
import Features from '../ui/Features';
import InterviewProblems from '../ui/Features/InterviewProblems';
import Testimonials from '../ui/NewTestimonials';
import FAQList from '../ui/FAQ';
import SignupInfo from '../ui/SignUpInfo';
import Footer from '../ui/Footer';
import { SpecialOffer } from '../ui/SnackBar';
// import BottomRegionalsPackageBar from '../Home/Info/PricingNavigateBars/BottomRegionalsPackageBar';

const langContent = {
  tamil: {
    title: 'இனி தமிழில் programming கற்கலாம்.',
    subTitle: 'Mothertong ஐ பயன்படுத்தி எளிமையான தமிழில் animation உடன் programming கற்கலாம்.',
  },
  hindi: {
    title: 'अब आप सीख सकते हैं programming हिंदी में।',
    subTitle: 'Mothertong का उपयोग करके, आप सरल हिंदी में एनीमेशन के साथ कार्यक्रम सीख सकते हैं।',
  },
  kannada: {
    title: 'ಈಗ ನೀವು ಕನ್ನಡದಲ್ಲಿ ಪ್ರೋಗ್ರಾಮಿಂಗ್ ಕಲಿಯಬಹುದು.',
    subTitle: 'ಮದರ್‌ಟಾಂಗ್ ಬಳಸಿ, ಸರಳ ಕನ್ನಡದಲ್ಲಿ ನೀವು ಅನಿಮೇಷನ್‌ನೊಂದಿಗೆ ಕಾರ್ಯಕ್ರಮವನ್ನು ಕಲಿಯಬಹುದು.',
  },
  telugu: {
    title: 'ఇప్పుడు మీరు తెలుగులో ప్రోగ్రామింగ్ నేర్చుకోవచ్చు.',
    subTitle: 'మదర్‌టాంగ్ ఉపయోగించి, మీరు యానిమేషన్‌తో ప్రోగ్రామ్‌ను సాధారణ తెలుగులో నేర్చుకోవచ్చు.',
  },
  bengali: {
    title: 'আপনি এখন বাংলায় প্রোগ্রামিং শিখতে পারেন।',
    subTitle: 'মাদারটং ব্যবহার করে আপনি বাংলায় সাধারণ অ্যানিমেশন সহ প্রোগ্রামিং শিখতে পারেন।',
  },
};

class Home extends Component {
  state = {
    snackbar: false,
    offerSnackBar: localStorage.getItem('snackBarClosedDate') ? false : true,
    browser: '',
    infoStatus: false,
    priceApiLoading: false,
    priceDetails: {},
    oneYearPlan: {},
    localPricing: true, // default local pricing
    language: '',
    coursesLanguage: '',
    staticPrimePrice: '',
    staticOldPrice: '',
    headerSnackbar: false,
    yearEndOffer: true,
    country: '',
    headerOfferSnackbar: false,
    headerOfferLink: '',
    headerOfferName: '',
    headerOfferPath: '',
    headerOfferDayCount: 0,
    headerOfferImg: '',
    headerOfferPercent: '',
    headerOfferEndTime: '',
    headerOfferTitle: '',
    specialPrice: [],
    scrolling: false,
    scrollHeight: 0,
    isPricingBar: false,
    bottomOfferBar: false,
    apiOfferResult: null,
    courseCategory: 'animation',
    offerApiLoading: true,
    primeOfferPrice: '',
  };

  async componentDidMount() {
    const { userID, email, history, userLocationDetails, updateUserLocationDetails, userPaidStatus, paidPath } = this.props;
    const { localPricing } = this.state;
    firstVisited();

    let countryCode = await getCountryCode(userLocationDetails, updateUserLocationDetails);
    this.setState({ country: countryCode });

    localStorage.setItem('pr_cd', false);
    localStorage.setItem('offer', false);
    this.props.updateCheckoutPromoCode(false);
    this.props.updateOfferStatus(false);
    this.props.updateOfferName('');

    window.addEventListener('scroll', this.handleScroll);

    let specialPrice;
    // let ltdSpecialPrice;

    let Urllanguage = history.location.pathname.split('/')[1];
    if (Urllanguage) {
      this.setState({
        language: Urllanguage,
        coursesLanguage: regionalsLangObject[Urllanguage] && regionalsLangObject[Urllanguage]['native'],
        // staticPrimePrice: regionalsLangObject[Urllanguage] && regionalsLangObject[Urllanguage]['staticPrimePrice'],
        // staticOldPrice: regionalsLangObject[Urllanguage] && regionalsLangObject[Urllanguage]['staticOldPrice'],
      });

      let regionalsUnPaidUser =
        !userPaidStatus ||
        paidPath === undefined ||
        (paidPath && animatedRegionalsPaths.every((path) => !paidPath.includes(path)) && !paidPath.includes(`prime-membership-${Urllanguage}`));

      if (countryCode === 'IN' && regionalsUnPaidUser) {
        /* offer snackbar call */
        try {
          let offerResult = await Axios.get(CONFIG.logsDomain + `/lboff?country=${countryCode}&type=regionals-${Urllanguage}`),
            offerResultData;

          if (offerResult && offerResult.data && offerResult.data.length !== 0) {
            offerResultData = offerResult.data[0];
            let { offerName, offerPath, promoCode, dayCount, offerImgUrl, offerPercent, offerHeading, endTime, primeOfferPrice } = offerResultData;
            setTimeout(() => {
              this.setState({
                apiOfferResult: true,
                headerOfferSnackbar: true,
                headerOfferName: offerName,
                headerOfferPath: offerPath,
                headerOfferLink: promoCode,
                headerOfferDayCount: dayCount,
                headerOfferImg: offerImgUrl,
                headerOfferPercent: offerPercent,
                headerOfferTitle: offerHeading,
                headerOfferEndTime: endTime,
                primeOfferPrice: primeOfferPrice,
                offerApiLoading: false,
              });
            }, 1000);
          } else this.setState({ apiOfferResult: false, offerApiLoading: false });
        } catch (error) {
          this.setState({ offerApiLoading: false });
          console.log('offer error ', error);
        }

        /* pricing call */
        // try {
        //   let regionalType = 'regional';
        //   this.setState({ priceApiLoading: true });
        //   let result = await Axios.get(CONFIG.apiURL + `/pricing?countryCode=${countryCode}&type=${regionalType}&lang=${Urllanguage}`);

        //   // if (!localStorage.getItem('snackBarClosedDate') || (result.data.offerDetails && result.data.offerDetails.createdAt > localStorage.getItem('snackBarClosedDate'))) {
        //   //   this.setState({ offerSnackBar: true });
        //   // } else {
        //   //   this.setState({ offerSnackBar: false });
        //   // }

        //   if (result && result.data) {
        //     // specialPrice = result && result.data.filter((ele) => ele.specialPrice !== undefined && ele.specialPrice === true);
        //     // ltdSpecialPrice = result && result.data.filter((ele) => ele._id && ele._id.includes('-ltd-spl-'));
        //     this.setState({
        //       priceDetails: result.data,
        //       priceApiLoading: false,
        //       // specialPrice: specialPrice[0],
        //       // specialPrice: ltdSpecialPrice[0],
        //       // isPricingBar: true,
        //     });

        //     let oneYearGlobal;
        //     let oneYearLocal;

        //     if (result.data.showToggle === true && localPricing === true) {
        //       if (Object.keys(result.data.local).length !== 0) {
        //         oneYearLocal = result.data.local.oneYear;
        //       }
        //       this.setState({ oneYearPlan: oneYearLocal });
        //     } else {
        //       if (Object.keys(result.data.global).length !== 0) {
        //         oneYearGlobal = result.data.global.oneYear;
        //       }
        //       this.setState({ oneYearPlan: oneYearGlobal });
        //     }
        //   } else {
        //     this.setState({ priceApiLoading: false });
        //   }
        // } catch (error) {
        //   this.setState({ priceApiLoading: false });
        // }
      }
    }

    // if (countryCode === 'IN' && specialPrice) {
    //   setTimeout(() => {
    //     this.setState({ headerOfferSnackbar: true });
    //   }, 1000);
    // }

    // document.addEventListener('contextmenu', this.handleContextMenu);

    // Initialise the chatbot
    // const name = this.props.name.split(' ');
    // const firstName = name[0];
    // const lastName = name[1];
    // window.fcWidget && setFCUserProperties(userID, firstName, lastName, email);

    let sBrowser = browserDetect();
    this.setState({ browser: sBrowser });

    // Show info bar
    setTimeout(() => {
      this.setState({ infoStatus: false });
    }, 1500);

    // To get referrer url and store in local storage
    const url = window.location.search;
    const referrer_medium = getParams(url);
    url && localStorage.setItem('referrer_medium', JSON.stringify({ ...referrer_medium, medium: document.referrer }));
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  // handleContextMenu = (event) => {
  //   event.preventDefault();
  // };

  handleSnackBarClose = () => {
    this.setState({ snackbar: false });
  };

  handleOfferSnackBarClose = () => {
    let todayDate = new Date().toISOString();
    localStorage.setItem('snackBarClosedDate', todayDate);
    this.setState({ offerSnackBar: false });
  };

  handleInfoBar = () => {
    this.setState({ infoStatus: false });
  };

  handleHeaderSnackbar = () => {
    this.setState({ headerSnackbar: false });
  };

  handleYearEndOffer = () => {
    this.setState({ yearEndOffer: false });
  };

  handleScroll = () => {
    this.setState({
      scrolling: true,
      scrollHeight: window.scrollY,
    });
    let top = window.scrollY <= 0;
    if (top === true) {
      this.setState({ scrolling: false });
    }
  };

  closeHeaderOfferSnackbar = () => {
    this.setState({ headerOfferSnackbar: false });
  };

  closeBottomOfferBar = () => {
    this.setState({ bottomOfferBar: false });
  };

  handleCourseCategory = (category) => {
    this.setState({ courseCategory: category });
  };

  render() {
    const { history, pricingPlan, totalAmountToPay, saveSubscriptionType, userPaidStatus, paidPath } = this.props;
    const {
      browser,
      snackbar,
      infoStatus,
      priceApiLoading,
      priceDetails,
      offerSnackBar,
      language,
      coursesLanguage,
      headerSnackbar,
      yearEndOffer,
      country,
      headerOfferSnackbar,
      headerOfferName,
      headerOfferPath,
      headerOfferLink,
      headerOfferDayCount,
      headerOfferImg,
      headerOfferEndTime,
      headerOfferTitle,
      headerOfferPercent,
      specialPrice,
      scrolling,
      scrollHeight,
      isPricingBar,
      oneYearPlan,
      bottomOfferBar,
      apiOfferResult,
      courseCategory,
      primeOfferPrice,
      offerApiLoading,
    } = this.state;
    const browserList = ['Microsoft Internet Explorer', 'Microsoft Edge', 'Apple Safari'];
    const browserSupport = browserList.includes(browser);
    const cloudFront = CONFIG.cloudFront;
    let bannerJffLink = `/signup/?lb_content=${window.location.hostname + window.location.pathname}&lb_cta=jff-main-btn`;
    let regionalsPricingLink = `/regionals-${language}-pricing/?lb_content=${window.location.hostname + window.location.pathname}&lb_cta=rgnls-price-bar-vp_btn`;

    if (language) {
      return (
        <Fragment>
          <Helmet>
            <title>Log2Base2&reg; - World's First Visual Learning Platform</title>
            <meta name="description" content="Visualize programming, data structures & algorithms and prepare for the coding interview. Join for Free!" />
            {process.env.REACT_APP_STAGE === 'prod' ? <meta name="robots" content="index, follow" /> : <meta name="robots" content="noindex, nofollow" />}
            {process.env.REACT_APP_STAGE === 'prod' ? <meta name="googlebot" content="index" /> : <meta name="googlebot" content="noindex" />}
          </Helmet>
          {priceDetails.isOfferEnabled && priceDetails.offerDetails.showsnackBar ? (
            <SpecialOffer
              showSnakeBar={offerSnackBar}
              isFromHome={true}
              history={history}
              priceDetails={priceDetails}
              handleSnackBarClose={this.handleOfferSnackBarClose}
            ></SpecialOffer>
          ) : null}
          {headerSnackbar && <HeaderSnackbar handleHeaderSnackbar={this.handleHeaderSnackbar} />}
          {headerOfferSnackbar && (
            <InfoBar
              type={'regionalsOfferInfo'}
              country={country}
              language={language}
              coursesLanguage={coursesLanguage}
              headerOfferName={headerOfferName}
              headerOfferPath={headerOfferPath}
              headerOfferLink={headerOfferLink}
              headerOfferDayCount={headerOfferDayCount}
              headerOfferImg={headerOfferImg}
              headerOfferPercent={headerOfferPercent}
              headerOfferTitle={headerOfferTitle}
              headerOfferEndTime={headerOfferEndTime}
              handleInfoBar={this.closeHeaderOfferSnackbar}
            />
          )}
          <Header
            variant="regionals"
            language={language}
            coursesLanguage={coursesLanguage}
            cloudFront={cloudFront}
            fixed={true}
            headerSnackbar={headerSnackbar}
            headerOfferSnackbar={headerOfferSnackbar}
            isScrolling={scrolling}
            primeOfferPrice={primeOfferPrice}
            primeOfferPriceLoading={offerApiLoading}
            primeOfferLink={headerOfferLink}
          />
          <Banner bannerJffLink={bannerJffLink} cloudFront={cloudFront} history={history} browserSupport={browserSupport} />
          <SiteStats />
          <CompanyLogos cloudFront={cloudFront} />
          {/*{apiOfferResult === false &&
          priceDetails &&
          Object.keys(priceDetails).length !== 0 &&
          (!userPaidStatus ||
            paidPath === undefined ||
            (paidPath && animatedRegionalsPaths.every((path) => !paidPath.includes(path)) && !paidPath.includes(`prime-membership-${language}`))) ? (
            <RegionalsPrimePricingBar
              scrollHeight={scrollHeight}
              country={country}
              isPricing={priceDetails && Object.keys(priceDetails).length !== 0}
              priceDetails={priceDetails}
              coursesLanguage={coursesLanguage}
              navigatePricingLink={regionalsPricingLink}
              handleAllAccessClick={(priceValues) =>
                handlePremiumPackage({
                  pricing: priceValues,
                  pricingPlan,
                  origin: 'Pricing',
                  history,
                  totalAmountToPay,
                  subscriptionType: 'yearly',
                  saveSubscriptionType,
                })
              }
            />
          ) : null}*/}
          <SingleTestimonial cloudFront={cloudFront} />
          <Courses history={history} language={language} coursesLanguage={coursesLanguage} />
          {/*{priceApiLoading ? (
            <PriceCardSkeleton />
          ) : (
            <Fragment>
              {priceDetails && oneYearPlan && Object.keys(oneYearPlan).length !== 0 ? (
                <PriceCard CtaLink={`/regionals-${language}-pricing/?lb_content=${window.location.hostname + window.location.pathname}&lb_cta=rgnl-prc_btn`}>
                  <h4 className="fs-20 pb-2">
                    Get unlimited access to <span className="headingFont weight-600">all {coursesLanguage} courses</span> for{' '}
                    <span className="d-inline-block">
                      <span className="headingFont weight-600">
                        {oneYearPlan.currencySymbol}
                        {oneYearPlan.offerPrice}
                      </span>{' '}
                      / year.
                    </span>
                  </h4>
                  {language === 'tamil' && (
                    <div className="text-light d-flex align-items-center justify-content-center justify-content-lg-start flex-wrap pb-2">
                      <p className="mt-1 mr-2">✓ Animated {coursesLanguage} courses</p> <p className="mt-1 ml-2">✓ Expert {coursesLanguage} courses</p>
                    </div>
                  )}
                  <p>
                    Limited-time offer. Unlock your learning potential in your native language. <span className="d-inline-block">Act now, don't miss out!</span>
                  </p>
                </PriceCard>
              ) : null}
            </Fragment>
          )}*/}
          <Features cloudFront={cloudFront} />
          <InterviewProblems cloudFront={cloudFront} />
          {/*country === 'IN' && priceDetails && Object.keys(priceDetails).length ? (
            <RegionalsPricing
              history={history}
              language={language}
              coursesLanguage={coursesLanguage}
              countryCode={country}
              priceDetails={priceDetails}
              handleAllAccessClick={(priceValues) =>
                handlePremiumPackage({
                  pricing: priceValues,
                  pricingPlan,
                  origin: 'Pricing',
                  history,
                  totalAmountToPay,
                  subscriptionType: 'yearly',
                  saveSubscriptionType,
                })
              }
            />
            ) : null*/}
          <Testimonials variant={'regionals'} />
          <FAQList variant="regionals" />
          <SignupInfo cloudFront={cloudFront} variant={'regionals'} coursesLanguage={coursesLanguage} />
          <Footer
            variant="regionals"
            // isPricingBar={
            //   apiOfferResult === false &&
            //   priceDetails &&
            //   Object.keys(priceDetails).length !== 0 &&
            //   (!userPaidStatus || paidPath === undefined || (paidPath && animatedRegionalsPaths.every((path) => !paidPath.includes(path)) && !paidPath.includes(`prime-membership-${language}`)))
            // }
          />
          {/*{infoStatus && <InfoBar type={'promoCode'} history={history} handleInfoBar={this.handleInfoBar} handlePromocodePricing={() => history.push('/pricing')} />}*/}
          {/*{yearEndOffer && <InfoBar type={'originalsBottomBar'} handleInfoBar={this.handleYearEndOffer} />}*/}
          {/*{apiOfferResult === true && bottomOfferBar && (
            <BottomRegionalsPackageBar
              forPrime
              country={country}
              language={language}
              coursesLanguage={coursesLanguage}
              headerOfferName={headerOfferName}
              headerOfferPath={headerOfferPath}
              headerOfferLink={headerOfferLink}
              headerOfferDayCount={headerOfferDayCount}
              headerOfferImg={headerOfferImg}
              handleInfoBar={this.closeBottomOfferBar}
            />
          )}*/}
          {/*{bottomOfferBar && language === 'tamil' && priceDetails && Object.keys(priceDetails).length !== 0 && (
            <BottomRegionalsPackageBar
              forPrime
              country={country}
              language={language}
              coursesLanguage={coursesLanguage}
              priceDetails={priceDetails && priceDetails}
              handleInfoBar={this.closeHeaderOfferSnackbar}
            />
          )}*/}
        </Fragment>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = ({ User, Dashboard }) => ({
  userID: User.username,
  name: User.name,
  email: User.email,
  userLocationDetails: User.locationDetails,
  userPaidStatus: Dashboard.trialAndInProgress && Dashboard.trialAndInProgress.paidStatus,
  paidPath: Dashboard.trialAndInProgress && Dashboard.trialAndInProgress.path,
});

const mapDispatchToProps = (dispatch) => ({
  updateUserLocationDetails: (locationDetails) => dispatch(updateUserLocationDetails(locationDetails)),
  pricingPlan: (selectedCourses) => dispatch(pricingPlan(selectedCourses)),
  totalAmountToPay: (amountToPay) => dispatch(totalAmountToPay(amountToPay)),
  saveSubscriptionType: (subscriptionType) => dispatch(saveSubscriptionType(subscriptionType)),
  updateCheckoutPromoCode: (promoCode) => dispatch(updateCheckoutPromoCode(promoCode)),
  updateOfferStatus: (status) => dispatch(updateOfferStatus(status)),
  updateOfferName: (value) => dispatch(updateOfferName(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
